export const LOAD_PHONETICS_EXERCISES_SUCCESS = 'LOAD_PHONETICS_EXERCISES_SUCCESS';
export const LOAD_MORPHOLOGY_DATA_SUCCESS = 'LOAD_MORPHOLOGY_DATA_SUCCESS';

export const ENG_IPA_INPUT_CHANGED = 'ENG_IPA_INPUT_CHANGED';
export const ENG_IPA_CHECK_SCORE = 'ENG_IPA_CHECK_SCORE';

export const IPA_ENG_INPUT_CHANGED = 'IPA_ENG_INPUT_CHANGED';
export const IPA_ENG_CHECK_SCORE = 'IPA_ENG_CHECK_SCORE';

export const VIDEO_IPA_INPUT_CHANGED = 'VIDEO_IPA_INPUT_CHANGED';
export const VIDEO_IPA_CHECK_SCORE = 'VIDEO_IPA_CHECK_SCORE';

export const TOGGLE_PHONETICS_ANSWERS = 'TOGGLE_PHONETICS_ANSWERS';
export const TOGGLE_MORPHOLOGY_ANSWERS = 'TOGGLE_MORPHOLOGY_ANSWERS';

export const MORPHOLOGY_INPUT_CHANGED = 'MORPHOLOGY_INPUT_CHANGED';
export const MORPHOLOGY_CHECK_SCORE = 'MORPHOLOGY_CHECK_SCORE';

export const AUTH_SUCCESS = 'AUTH_SUCCESS';
export const AUTH_FAIL = 'AUTH_FAIL';

